/* ============================================================
   BLOG STICKY BAR — blog-sticky.js
   A "drive" bar for article pages. No cart logic — the CTA is a
   plain link. JS only handles scroll-based hide near the end.

   Show: immediately, from the top of the page.
   Hide: once the footer / related-articles section reaches the
         viewport, and STAY hidden past that point (so it never
         reappears at the very bottom of the page).
   ============================================================ */

class BlogStickyBar extends HTMLElement {
  constructor() {
    super();
    this.isVisible = false;
    this._atEnd    = false;  // reached the end region (latched)
  }

  connectedCallback() {
    this.bar = this.querySelector('.sticky-atc-bar');
    if (!this.bar) return;

    this._endEl =
      document.querySelector('.article__related') ||
      document.querySelector('footer') ||
      document.querySelector('[class*="footer"]');

    this._show();  // present from the top

    if (this._endEl) {
      /* Use the boundary element's top edge directly rather than raw
         isIntersecting. The bar hides as soon as the end region's top
         is within (viewport height + buffer) of the top of the screen,
         and stays hidden while scrolled at/below that — so it does NOT
         pop back when the element scrolls fully above the viewport. */
      this._onScroll = this._onScroll.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._onScroll();
    }
  }

  _onScroll() {
    if (!this._endEl) return;
    const rect = this._endEl.getBoundingClientRect();
    const vh   = window.innerHeight || document.documentElement.clientHeight;

    /* Hide when the end region's top has scrolled up into the lower
       part of the viewport (buffer keeps the bar from overlapping it),
       OR any time we're scrolled past it (rect.top < 0). */
    const buffer  = 80;
    const reached = rect.top <= (vh - buffer);

    this._atEnd = reached;
    this._evaluate();
  }

  _evaluate() {
    if (this._atEnd) this._hide();
    else this._show();
  }

  _show() {
    if (this.isVisible) return;
    this.isVisible = true;
    this.bar.classList.add('is-visible');
  }

  _hide() {
    if (!this.isVisible) return;
    this.isVisible = false;
    this.bar.classList.remove('is-visible');
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
  }
}

customElements.define('blog-sticky-bar', BlogStickyBar);